"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResourceUploadType;
(function (ResourceUploadType) {
    ResourceUploadType["ZipCodes"] = "zip_codes";
    ResourceUploadType["ServiceAreas"] = "service_areas";
    ResourceUploadType["Tasks"] = "task_create";
})(ResourceUploadType || (ResourceUploadType = {}));
exports.default = ResourceUploadType;
//# sourceMappingURL=ResourceUploadType.js.map